import styled, { type AnyStyledComponent } from 'styled-components';
import Button from '@splunk/react-ui/Button';
import { variables } from '@splunk/themes';

export const SecondaryActionButton = (container: AnyStyledComponent) => styled(
    Button
)`
    float: left;

    /* More specificity is required else this color declaration is overridden */
    ${container} & {
        color: ${variables.contentColorNegative};
    }
`;
